import { FunctionalComponent, h } from '@stencil/core';
import { icon } from '@fortawesome/fontawesome-svg-core';
// imports must be explicit to support tree-shaking for the icons, otherwise all of them are bundled together
// import { faArrowUpRightFromSquare, faChevronRight } from '@optimizely/axiom/src/components/Icon/icon-imports';
import * as Icons from '@optimizely/pro-light-svg-icons';

interface SVGIconProps {
  // icon name type is limited to the matching icons that are imported from icon-imports
  name: string;
  color?: 'white' | 'black';
  width?: number;
  height?: number;
}

export const SVGIcon: FunctionalComponent<SVGIconProps> = ({ name, color, width = 20, height = 16 }) => {

  // const svgIcon = icon(icons[name]);
  const faName = "fa" + toPascalCase(name);
  const svgIcon = icon(Icons[faName]);

  if (!svgIcon) {
    return null;
  }

  return (
    <svg {...svgIcon.abstract[0].attributes} width={width} height={height} color={color}>
      <path {...svgIcon.abstract[0].children[0].attributes} />
    </svg>
  );
};

const toPascalCase = str =>
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map(x => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase())
    .join('');